var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingYellowBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "1322px",
    height: "920px",
    viewBox: "0 0 1343 847",
    style: {
      enableBackground: "new 0 0 1322 920"
    },
    fill: "none",
    preserveAspectRatio: "none",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M939.812 95.7728C895.489 133.095 848.559 171.651 790.582 185.285C645.154 219.456 503.893 84.427 357.505 114.599C295.324 127.423 244.72 168.147 197.118 207.448C141.858 253.009 85.8576 299.473 46.7974 357.346C7.73722 415.219 -12.7059 487.371 9.59463 551.507C39.3036 637.049 139.23 697.944 140.401 788.102C141.32 860.033 76.7573 930.109 100.842 998.24C117.01 1043.95 171.98 1071.5 224.553 1069.59C277.125 1067.68 326.094 1040.97 363.499 1006.43C453.621 923.007 487.743 794.343 591.587 725.821C688.67 661.73 818.268 668.45 936.235 677.869C1030.33 685.401 1131.1 695.402 1201.65 752.132C1248.76 789.97 1284.62 849.101 1347.16 855.63C1408.62 862.035 1463.73 807.931 1472.37 751.445C1481.02 694.959 1454.82 639.298 1422.66 591.174C1390.48 542.974 1351.36 498.088 1329.62 445.031C1310.26 397.881 1305.62 346.676 1301.14 296.213C1294.41 219.611 1309.08 84.3969 1234.47 30.0986C1135.9 -41.6794 1016.24 31.5323 939.812 95.7728Z",
    fill: "url(#paint0_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 682.779,
    y1: 43.6798,
    x2: 775.666,
    y2: 1017.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7971"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingYellowBackground);
export default __webpack_public_path__ + "static/media/pending-yellow-background.a9bda2d21d8826442bbcaf8f0b064aee.svg";
export { ForwardRef as ReactComponent };